module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-LightItalic-WebM-7a008d402b517728e4fa8505567cd675.woff2";